// packages/shared/src/constants/datasource.constants.ts
// Single source of truth for datasource domain value-sets (ADR-20, section 5).

export const FMP_SYMBOL_CHANGE_FEED_LIMIT = 10_000;
export const FMP_INVALID_PROVIDER_DATE_ERROR_CODE = "INVALID_PROVIDER_DATE" as const;

// ── datasourceResultStatus ──────────────────────────────────────────────────
// Status of a datasource operation result (no "running" — this is the final
// result, not a process state).
export const DATASOURCE_RESULT_STATUS = ["completed", "failed"] as const;
export type TDatasourceResultStatus = (typeof DATASOURCE_RESULT_STATUS)[number];
export const DATASOURCE_RESULT_STATUS_OBJ = {
  COMPLETED: "completed",
  FAILED: "failed",
} as const satisfies Record<string, TDatasourceResultStatus>;

// ── fmpApiFamily ────────────────────────────────────────────────────────────
// FMP API family routed by the listing exchange: "stable" endpoints for US
// listings, path-style "v3" endpoints for known non-US exchanges.
export const FMP_API_FAMILY = ["stable", "v3"] as const;
export type TFmpApiFamily = (typeof FMP_API_FAMILY)[number];
export const FMP_API_FAMILY_OBJ = {
  STABLE: "stable",
  V3: "v3",
} as const satisfies Record<string, TFmpApiFamily>;

// ── fmpFailureReason ────────────────────────────────────────────────────────
// Why an FMP request area is paused.
export const FMP_FAILURE_REASON = ["access", "rate-limit", "transient"] as const;
export type TFmpFailureReason = (typeof FMP_FAILURE_REASON)[number];
export const FMP_FAILURE_REASON_OBJ = {
  ACCESS: "access",
  RATE_LIMIT: "rate-limit",
  TRANSIENT: "transient",
} as const satisfies Record<string, TFmpFailureReason>;
